export default __webpack_public_path__ + "static/media/Hindi_am_1.0e41ba76.mp3";